import type { QuoteRow } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { MyQuoteRow } from './my-quote-row';

interface MyQuoteTableProps {
  readonly rows: readonly QuoteRow[];
}

const HEAD_CLASS = 'pb-3 pr-4 text-xs font-normal text-muted-foreground last:pr-0';

/** 내 견적 표 — 상자 없이 굵은 머리선과 얇은 줄 선으로 나눈다(상품 상세 표와 같은 결). */
export const MyQuoteTable = ({ rows }: MyQuoteTableProps): ReactElement => (
  <table aria-label="내 견적 목록" className="w-full text-sm">
    <thead className="text-left">
      <tr className="border-b border-foreground">
        <th scope="col" className={`${HEAD_CLASS} pl-1 sm:pl-2`}>
          견적 번호
        </th>
        <th scope="col" className={HEAD_CLASS}>
          상품명
        </th>
        <th scope="col" className={`${HEAD_CLASS} hidden text-right md:table-cell`}>
          수량
        </th>
        <th scope="col" className={`${HEAD_CLASS} hidden md:table-cell`}>
          요청일
        </th>
        <th scope="col" className={`${HEAD_CLASS} hidden md:table-cell`}>
          상태
        </th>
        <th scope="col" className={`${HEAD_CLASS} text-right`}>
          견적 금액
        </th>
        <th scope="col" className={`${HEAD_CLASS} hidden lg:table-cell`}>
          <span className="sr-only">상세</span>
        </th>
      </tr>
    </thead>
    <tbody>
      {rows.map((row) => (
        <MyQuoteRow key={row.id} row={row} />
      ))}
    </tbody>
  </table>
);
